import axios from 'axios';
import { messageService } from './services/subscriberService';

const axio = axios.create({
    baseURL : ""
    // baseURL : " http://staging-service-550164730.us-east-1.elb.amazonaws.com/"
    // baseURL : " http://prod-service-1399505486.us-east-1.elb.amazonaws.com/"
});

axio.interceptors.request.use(request => {
    if(messageService.show) {
        messageService.sendMessage(true);
    } else {
        messageService.show = true;
    }
    request.headers = {
        ...request.headers,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'multipart/form-data',
    }
    return request ;
},
error => {
    messageService.sendMessage(false);
    return Promise.reject(error);
});

axio.interceptors.response.use(response => {
    messageService.sendMessage(false);
    return response.data ;
},
error => {
    messageService.sendMessage(false);
    return Promise.reject(error);
});

axio.defaults.headers.common['content-language'] = 'en';

export default axio;